var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"posts-stats stats"},[_c('h4',{staticClass:"primary--text mb-4"},[_vm._v(_vm._s(_vm.$t("common.groups")))]),_c('div',{staticClass:"stat-boxes"},_vm._l((_vm.boxes),function(box,i){return _c('StatBox',{key:i,attrs:{"label":box.label,"value":box.value,"loading":_vm.loading}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }